import type { SVGProps } from "react";
// generated from CircleCheck.svg — do not edit manually
// prettier-ignore
export default function CircleCheck(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 20 6 L 11.062 15 L 7 10.909 M 22 12 C 22 17.523 17.523 22 12 22 C 6.477 22 2 17.523 2 12 C 2 6.477 6.477 2 12 2 C 17.523 2 22 6.477 22 12 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
